import type { MouseEventHandler } from 'react'

export type CmsCtaIntent = 'link' | 'start_onboarding_wizard' | 'start_onboarding_menu'
export type CmsCtaVariant = 'primary' | 'secondary'

export type RawCmsCta = {
  text: string
  intent?: CmsCtaIntent
  variant?: CmsCtaVariant
  href?: string
}

export type CmsCtaIntentHandlers = Partial<
  Record<
    Exclude<CmsCtaIntent, 'link'>,
    {
      href: string
      onClick?: MouseEventHandler<HTMLElement>
    }
  >
>

export type CtaLinkData = {
  text: string
  href: string
  variant?: CmsCtaVariant
  onClick?: MouseEventHandler<HTMLElement>
}

export function mapCmsCta(
  cta?: RawCmsCta,
  intentHandlers: CmsCtaIntentHandlers = {},
): CtaLinkData | undefined {
  if (!cta?.text) {
    return undefined
  }

  const intent = cta.intent ?? 'link'
  const variant = cta.variant ?? 'primary'

  if (intent === 'link') {
    if (!cta.href) {
      return undefined
    }

    return {
      text: cta.text,
      variant,
      href: cta.href,
    }
  }

  const resolvedIntent = intentHandlers[intent]

  if (!resolvedIntent?.href) {
    return undefined
  }

  return {
    text: cta.text,
    variant,
    href: resolvedIntent.href,
    onClick: resolvedIntent.onClick,
  }
}
